export default __webpack_public_path__ + "static/media/c1.25a155e3.png";